// Services
import { getVessels, VesselsNamesSchema } from '@services/apiGateway';

/**
 * Controller function to fetch vessel data.
 * This function is used as a query function for the @tanstack/react-query.
 *
 * @async
 * @function vesselController
 * @returns {Promise} A promise that resolves to the vessel data parsed with VesselsNamesSchema.
 */
export const vesselController = async () => {
  const { data } = await getVessels();

  return VesselsNamesSchema.parse(data);
};
